export const checkoutViews = Object.freeze({
  userIdentification: {
    name: 'user-identification',
    component: 'user-identification',
    step: 1
  },
  userIdentificationExisting: {
    name: 'identification-existing',
    component: 'user-identification-existing',
    step: 1
  },
  userIdentificationFreeNumber: {
    name: 'identification-new-number',
    component: 'user-identification-free-number',
    step: 1
  },
  userIdentificationNewCable: {
    name: 'identification-new-cable',
    component: 'user-identification-new-cable',
    step: 1
  },
  checkoutPreview: {
    name: 'cart-preview',
    component: 'the-checkout-preview-cart',
    step: 2,
    navigationVisible: true,
    valid: true,
    next: 'checkout-payment',
    previous: 'user-identification'
  },
  checkoutPayment: {
    name: 'checkout-payment',
    component: 'checkout-payment',
    step: 3,
    navigationVisible: true, // TBD
    valid: false,
    next: 'order-confirmation',
    previous: 'cart-preview'
  },
  checkoutConfirmation: {
    name: 'order-confirmation',
    component: 'order-confirmation',
    previous: 'checkout-payment'
  }
})
